/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ApiKeysUpdateKeyRequestBody = {
  /**
   * API key identifier returned by apiKeys.createKey or apiKeys.listKeys.
   */
  keyId: string;
  /**
   * New API key name. Set null to remove the name. Omit to keep the current name.
   */
  name?: string | null | undefined;
  /**
   * Whether the API key can authenticate. Omit to keep the current state.
   */
  enabled?: boolean | undefined;
  /**
   * Complete replacement permission set. Every permission must be a supported URN in the authenticated workspace
   *
   * @remarks
   * and within the caller's permissions. Omit to keep the current permissions.
   */
  permissions?: Array<string> | undefined;
};

/** @internal */
export type V1ApiKeysUpdateKeyRequestBody$Outbound = {
  keyId: string;
  name?: string | null | undefined;
  enabled?: boolean | undefined;
  permissions?: Array<string> | undefined;
};

/** @internal */
export const V1ApiKeysUpdateKeyRequestBody$outboundSchema: z.ZodType<
  V1ApiKeysUpdateKeyRequestBody$Outbound,
  z.ZodTypeDef,
  V1ApiKeysUpdateKeyRequestBody
> = z.object({
  keyId: z.string(),
  name: z.nullable(z.string()).optional(),
  enabled: z.boolean().optional(),
  permissions: z.array(z.string()).optional(),
});

export function v1ApiKeysUpdateKeyRequestBodyToJSON(
  v1ApiKeysUpdateKeyRequestBody: V1ApiKeysUpdateKeyRequestBody,
): string {
  return JSON.stringify(
    V1ApiKeysUpdateKeyRequestBody$outboundSchema.parse(
      v1ApiKeysUpdateKeyRequestBody,
    ),
  );
}
